//Imports
import React, { useCallback, useEffect } from "react";

//Controls
import { Button, Modal } from "@gpstrackit/gtc-react-controls";

//Components
import {
    NotificationManager,
    NotificationContainer,
} from "Components/Notifications";

//Hooks
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

//Actions
import { manageDeleteManageWorkOrderType, reset } from "./redux/slice";

const DeleteManageWorkOrderType = ({ refresh }) => {

    //Redux
    const dispatch = useDispatch();
    const { open, loading, result, error, workOrderType, workOrderTypeList } = useSelector((state) => state.manageDeleteManageWorkOrderTypeRedux);

    //Language
    const { messages } = useIntl();

    //Handlers and utils
    const handleClose = useCallback(() => dispatch(reset()), []);

    const handleDeleteSubmit = useCallback(() => {
        if (workOrderType) {
            dispatch(manageDeleteManageWorkOrderType({ ids: [workOrderType?.id] }));
        }
        if (workOrderTypeList?.length) {
            let ids = workOrderTypeList.map((item) => item?.id)
            dispatch(manageDeleteManageWorkOrderType({ ids: ids }));
        }
    }, [workOrderType, workOrderTypeList]);

    //Effects
    useEffect(() => {
        if (error) {
            let errorMessage = messages["errorMessage"];
            const errorLower = error?.error?.toLowerCase();
            if (errorLower.includes('are in use')) {
                errorMessage = messages['manage_deleteWorkOrderTypes_are_in_use']
            }
            NotificationManager.error(
                errorMessage,
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ error: null }));
        }
    }, [error]);

    useEffect(() => {
        if (!result) return;
        if (result?.delete) {
            const messageSuccess = workOrderType
                ? messages['manage_deleteWorkOrderType_successMessage']
                : messages['manage_deleteWorkOrderTypes_successMessage'];

            NotificationManager.success(
                messageSuccess,
                messages["success"],
                3000,
                null,
                null,
                "success"
            );
            refresh();
            dispatch(reset());
        } else {
            NotificationManager.error(
                messages["errorMessage"],
                messages["error"],
                3000,
                null,
                null,
                "error"
            );
            dispatch(reset({ result: null }));
        }
    }, [result]);

    return (
        <Modal
            title={
                workOrderType
                    ? messages['manage_deleteWorkOrderType_title']
                    : messages['manage_deleteWorkOrderTypes_title']
            }
            size="small"
            open={open}
            handleClose={handleClose}
            loading={loading}
            footer={
                <div>
                    <Button
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                        onClick={() => handleClose()}
                        isDisabled={loading}
                    >
                        {messages["cancel"]}
                    </Button>
                    <Button
                        variant="warning"
                        onClick={() => handleDeleteSubmit()}
                        isDisabled={loading}
                    >
                        {messages["delete"]}
                    </Button>
                </div>
            }
        >
            <div style={{ padding: "10px 25px" }}>
                <p>{workOrderType ? messages['manage_deleteWorkOrderType_description'] : messages['manage_deleteWorkOrderTypes_description']}</p>
                <ul>
                    {workOrderType ? (
                        <li style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                            {workOrderType?.name}
                        </li>
                    ) : (
                        workOrderTypeList?.map((crew, index) => (
                            <li key={index} style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                                {crew.name}
                            </li>
                        ))
                    )}
                </ul>
            </div>
            <NotificationContainer />
        </Modal>
    );
};

export default DeleteManageWorkOrderType;